import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import Input from '@material-ui/core/Input';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FilterListIcon from '@material-ui/icons/FilterList';

import Select from '../../Select';
import { buildSelectItems } from './utils';
import chartsSelectSlice from './ChartsSelectSlice';

const ChartsSelect = ({ page }) => {
	const { t } = useTranslation();
	const [chartSelectOpened, setChartSelectOpened] = useState(false);
	const charts = useSelector(state => state.selectedDesign.detail.charts);
	const selectedCharts = useSelector(state => state.chartsSelect.selectedCharts);
	const dispatch = useDispatch();

	const buttonId = 'chartsSelectButton';
	const inputId = 'charts-select';

	useEffect(() => {
		const allCharts = charts.map(chart => chart.chartName);

		allCharts.forEach(chart => {
			document.getElementById(chart + '-chart-tile').style.display = selectedCharts[page].includes(chart)
				? 'list-item'
				: 'none';
		});
	}, [charts, page, selectedCharts]);

	const getAllCharts = () => charts.map(chart => chart.chartName);

	const handleChartSelectOpen = () => {
		setChartSelectOpened(true);
	};

	const handleChartSelectClose = () => {
		setChartSelectOpened(false);
	};

	const handleChartSelect = event => {
		if (
			(!selectedCharts[page].includes('All') && event.target.value.includes('All')) ||
			JSON.stringify(event.target.value) === JSON.stringify(charts)
		) {
			dispatch(
				chartsSelectSlice.actions.setSelected({
					page,
					charts: getAllCharts().concat(['All'])
				})
			);
		} else if (selectedCharts[page].includes('All') && !event.target.value.includes('All')) {
			dispatch(
				chartsSelectSlice.actions.setSelected({
					page,
					charts: []
				})
			);
		} else if (
			selectedCharts[page].includes('All') &&
			event.target.value.includes('All') &&
			event.target.value.length - 1 < charts.length
		) {
			dispatch(
				chartsSelectSlice.actions.setSelected({
					page,
					charts: event.target.value.filter(chartId => chartId !== 'All')
				})
			);
		} else {
			dispatch(
				chartsSelectSlice.actions.setSelected({
					page,
					charts: event.target.value
				})
			);
		}
	};

	return (
		<Select
			button={
				<Tooltip title={t('components.design.selectCharts')}>
					<IconButton id={buttonId} htmlFor={inputId} aria-label="Select charts" onClick={handleChartSelectOpen}>
						<FilterListIcon />
					</IconButton>
				</Tooltip>
			}
			buttonId={buttonId}
			value={selectedCharts[page]}
			items={buildSelectItems(charts)}
			multiple
			open={chartSelectOpened}
			onOpen={handleChartSelectOpen}
			onClose={handleChartSelectClose}
			onChange={handleChartSelect}
			input={<Input id={inputId} />}
			renderValue={selected => selected.join(', ')}
		/>
	);
};

ChartsSelect.propTypes = {
	page: PropTypes.oneOf(['DESIGN', 'SUMMARY']).isRequired
};

export default ChartsSelect;
